import useSEO from 'hooks/useSEO'
import LPNavigation from '../landing/sections/LPNavigation'
import PricingSection from '../landing/sections/PricingSection'
import FAQSection from '../landing/sections/FAQSection'
import CTABanner from '../landing/sections/CTABanner'
import LPFooter from '../landing/sections/LPFooter'

export default function PricingPage() {
  useSEO({
    title: 'Pricing — Free Dividend Tracker Plans',
    description: 'Safe Dividend Tracker is free forever. Compare Free, Premium, and Pro plans — dividend calendar, DRIP projections, brokerage sync, covered call tracker, and smart alerts.',
    canonical: '/pricing',
  })

  return (
    <div className="min-h-screen bg-white">
      <LPNavigation />
      <div className="pt-20">
        <PricingSection />
        <FAQSection />
        <CTABanner
          headline="Start tracking dividends for free"
          subtext="No credit card required. Upgrade anytime."
          ctaText="Get Started Free"
          microcopy="Free plan forever · No credit card required"
        />
      </div>
      <LPFooter />
    </div>
  )
}
